var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMassage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 213.994,
    height: 192.57,
    viewBox: "0 0 213.994 192.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "massage-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 213.994,
    height: 192.57,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(0 0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(0 -0.005)",
    clipPath: "url(#massage-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M169.953,444.287V550.85a7.932,7.932,0,0,1-7.932,7.932H7.932A7.932,7.932,0,0,1,0,550.85V444.287a7.932,7.932,0,0,1,7.932-7.932H162.021a7.932,7.932,0,0,1,7.932,7.932",
    transform: "translate(0 -366.212)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M169.953,841.187v1.876a7.932,7.932,0,0,1-7.932,7.932H7.932A7.932,7.932,0,0,1,0,843.062v-1.877l77.942-51.961,7.032-4.688,7.039,4.693Z",
    transform: "translate(0 -658.424)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M169.953,444.243v6.021L89.173,504.12a7.556,7.556,0,0,1-8.385,0L42,478.255l-42-28v-6.016a7.932,7.932,0,0,1,7.932-7.932H162.021a7.932,7.932,0,0,1,7.932,7.932",
    transform: "translate(0 -366.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M794.822,51.368A51.373,51.373,0,1,1,743.45,0a51.373,51.373,0,0,1,51.373,51.373",
    transform: "translate(-580.828 0.005)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M920.023,127.089c0-4.181-2.836-6.439-6.872-6.439-3.761,0-6.512,1.947-9.312,4.722l-8.272-7.562c4.808-5.469,11.515-9.279,19.471-9.279,10.985,0,19.364,5.432,19.364,17.512,0,12.582-15.346,16.445-14.145,28.527H907.128c-2.079-14,12.895-19.756,12.895-27.481m-15.407,42.9c0-5.349,3.859-9.473,9.065-9.473s9.064,4.124,9.064,9.473c0,5.314-3.859,9.437-9.064,9.437s-9.065-4.123-9.065-9.437",
    transform: "translate(-751.608 -91.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M471.91,204.98h0a2.783,2.783,0,0,1-1.968-.815l-8.021-8.023-8.023,8.023a2.783,2.783,0,0,1-3.935-3.936l9.991-9.99a2.782,2.782,0,0,1,3.934,0l9.99,9.99a2.783,2.783,0,0,1-1.968,4.751",
    transform: "translate(-376.944 -158.974)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M480,297.68h0a2.386,2.386,0,0,1-1.687-.7l-6.877-6.878-6.878,6.879a2.387,2.387,0,0,1-1.687.7h0a2.386,2.386,0,0,1-1.687-4.073l8.566-8.565a2.385,2.385,0,0,1,3.373,0l8.565,8.565A2.386,2.386,0,0,1,480,297.68",
    transform: "translate(-386.46 -238.636)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M1140.906,783.307h0a3.083,3.083,0,0,1-2.18-.9l-8.887-8.889-8.889,8.889a3.083,3.083,0,1,1-4.36-4.361l11.07-11.069a3.082,3.082,0,0,1,4.359,0l11.069,11.069a3.083,3.083,0,0,1-2.18,5.264",
    transform: "translate(-936.337 -642.927)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M1149.871,886.022h0a2.643,2.643,0,0,1-1.869-.774l-7.62-7.621-7.622,7.622a2.644,2.644,0,1,1-3.739-3.739l9.492-9.49a2.642,2.642,0,0,1,3.737,0l9.49,9.49a2.644,2.644,0,0,1-1.869,4.513",
    transform: "translate(-946.88 -731.195)",
    fill: "#e761a0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassage);
export default __webpack_public_path__ + "static/media/massage.fdbf25534be6d444e53abf602fafd8c3.svg";
export { ForwardRef as ReactComponent };